import { MediaTypeEnum } from '../../../Common/Basic/enums/media-type.enum';

export enum MediaSubscriptionMediaTypeEnum {
    broadcast = 'BROADCAST', // TV / RADIO
    reddit = MediaTypeEnum.REDDIT,
    subReddit = 'REDDIT_SUBREDDIT',
    twitter = 'TWEET',
    facebook = MediaTypeEnum.FACEBOOK,
    instagram = MediaTypeEnum.INSTAGRAM,
    youtube = MediaTypeEnum.YOUTUBE,
    podcast = MediaTypeEnum.PODCAST,
    tiktok = MediaTypeEnum.TIKTOK,
    linkedin = MediaTypeEnum.LINKEDIN,
    bluesky = MediaTypeEnum.BLUESKY,
}

/** Shared by both AM subs and agents (social subscriptions) */
export type MediaRequestType =
    MediaTypeEnum.TV |
    MediaTypeEnum.RADIO |
    MediaTypeEnum.REDDIT |
    MediaSubscriptionMediaTypeEnum.subReddit |
    MediaSubscriptionMediaTypeEnum.twitter |
    MediaTypeEnum.FACEBOOK |
    MediaTypeEnum.INSTAGRAM |
    MediaTypeEnum.YOUTUBE |
    MediaTypeEnum.PODCAST |
    MediaTypeEnum.TIKTOK |
    MediaTypeEnum.LINKEDIN |
    MediaTypeEnum.BLUESKY;




export const subscriptionTypeIconMap = new Map<MediaSubscriptionMediaTypeEnum, string>([
    [ MediaSubscriptionMediaTypeEnum.broadcast, 'fa-solid fa-tower-cell' ],
    [ MediaSubscriptionMediaTypeEnum.reddit,    'fa-brands fa-reddit'    ],
    [ MediaSubscriptionMediaTypeEnum.subReddit, 'fa-brands fa-reddit'    ],
    [ MediaSubscriptionMediaTypeEnum.twitter,   'fa-brands fa-x-twitter' ],
    [ MediaSubscriptionMediaTypeEnum.facebook,  'fa-brands fa-facebook'  ],
    [ MediaSubscriptionMediaTypeEnum.instagram, 'fa-brands fa-instagram' ],
    [ MediaSubscriptionMediaTypeEnum.youtube,   'fa-brands fa-youtube'   ],
    [ MediaSubscriptionMediaTypeEnum.podcast,   'fa-solid fa-podcast'    ],
    [ MediaSubscriptionMediaTypeEnum.tiktok,    'fa-brands fa-tiktok'    ],
    [ MediaSubscriptionMediaTypeEnum.linkedin,  'fa-brands fa-linkedin'  ],
    [ MediaSubscriptionMediaTypeEnum.bluesky,   'fa-brands fa-bluesky'   ],
]);


/** Note: doesn't handle MediaSubscriptionMediaTypeEnum.broadcast */
export const mediaSubTypeToMediaTypeMap = new Map<MediaSubscriptionMediaTypeEnum, MediaTypeEnum>([
    [ MediaSubscriptionMediaTypeEnum.facebook,  MediaTypeEnum.FACEBOOK  ],
    [ MediaSubscriptionMediaTypeEnum.instagram, MediaTypeEnum.INSTAGRAM ],
    [ MediaSubscriptionMediaTypeEnum.reddit,    MediaTypeEnum.REDDIT    ],
    [ MediaSubscriptionMediaTypeEnum.twitter,   MediaTypeEnum.TWITTER   ],
    [ MediaSubscriptionMediaTypeEnum.youtube,   MediaTypeEnum.YOUTUBE   ],
    [ MediaSubscriptionMediaTypeEnum.podcast,   MediaTypeEnum.PODCAST   ],
    [ MediaSubscriptionMediaTypeEnum.tiktok,    MediaTypeEnum.TIKTOK    ],
    [ MediaSubscriptionMediaTypeEnum.linkedin,  MediaTypeEnum.LINKEDIN  ],
    [ MediaSubscriptionMediaTypeEnum.bluesky,   MediaTypeEnum.BLUESKY   ],
]);

/** Note: doesn't handle MediaSubscriptionMediaTypeEnum.broadcast */
export const mediaTypeToMediaSubTypeMap = new Map<MediaTypeEnum, MediaSubscriptionMediaTypeEnum>([
    [ MediaTypeEnum.FACEBOOK,  MediaSubscriptionMediaTypeEnum.facebook  ],
    [ MediaTypeEnum.INSTAGRAM, MediaSubscriptionMediaTypeEnum.instagram ],
    [ MediaTypeEnum.REDDIT,    MediaSubscriptionMediaTypeEnum.reddit    ],
    [ MediaTypeEnum.TWITTER,   MediaSubscriptionMediaTypeEnum.twitter   ],
    [ MediaTypeEnum.YOUTUBE,   MediaSubscriptionMediaTypeEnum.youtube   ],
    [ MediaTypeEnum.PODCAST,   MediaSubscriptionMediaTypeEnum.podcast   ],
    [ MediaTypeEnum.TIKTOK,    MediaSubscriptionMediaTypeEnum.tiktok    ],
    [ MediaTypeEnum.LINKEDIN,  MediaSubscriptionMediaTypeEnum.linkedin  ],
    [ MediaTypeEnum.BLUESKY,   MediaSubscriptionMediaTypeEnum.bluesky   ],
]);



export enum SocialMediaTypeApiEnum {
    facebook = MediaTypeEnum.FACEBOOK,
    instagram = MediaTypeEnum.INSTAGRAM,
    reddit = MediaTypeEnum.REDDIT,
    subReddit = 'REDDIT_SUBREDDIT',
    twitter = MediaTypeEnum.TWITTER,
    youtube = MediaTypeEnum.YOUTUBE,
    tiktok = MediaTypeEnum.TIKTOK,
    linkedin = MediaTypeEnum.LINKEDIN,
    bluesky = MediaTypeEnum.BLUESKY,
}



// Needed for TWEET to TWITTER
export const mediaSubscriptionMediaTypeEnumToSocialMediaTypeApiEnumMap = new Map<MediaRequestType, SocialMediaTypeApiEnum>([
    [ MediaTypeEnum.FACEBOOK,                   SocialMediaTypeApiEnum.facebook  ],
    [ MediaTypeEnum.YOUTUBE,                    SocialMediaTypeApiEnum.youtube   ],
    [ MediaSubscriptionMediaTypeEnum.twitter,   SocialMediaTypeApiEnum.twitter   ],
    [ MediaTypeEnum.INSTAGRAM,                  SocialMediaTypeApiEnum.instagram ],
    [ MediaTypeEnum.REDDIT,                     SocialMediaTypeApiEnum.reddit    ],
    [ MediaSubscriptionMediaTypeEnum.subReddit, SocialMediaTypeApiEnum.subReddit ],
    [ MediaTypeEnum.TIKTOK,                     SocialMediaTypeApiEnum.tiktok    ],
    [ MediaTypeEnum.LINKEDIN,                   SocialMediaTypeApiEnum.linkedin  ],
    [ MediaTypeEnum.BLUESKY,                    SocialMediaTypeApiEnum.bluesky   ]
]);

export const mediaRequestTypeToStringMap = new Map<MediaRequestType, string>([
    [ MediaTypeEnum.FACEBOOK,                   'Facebook'    ],
    [ MediaTypeEnum.YOUTUBE,                    'YouTube'     ],
    [ MediaSubscriptionMediaTypeEnum.twitter,   'X'           ],
    [ MediaTypeEnum.INSTAGRAM,                  'Instagram'   ],
    [ MediaTypeEnum.REDDIT,                     'Reddit user' ],
    [ MediaSubscriptionMediaTypeEnum.subReddit, 'Sub Reddit'  ],
    [ MediaTypeEnum.TIKTOK,                     'TikTok'      ],
    [ MediaTypeEnum.LINKEDIN,                   'LinkedIn'    ],
    [ MediaTypeEnum.BLUESKY,                    'Bluesky'     ]
]);


// Excluded some media subscription types even if they're provisioned
export const allowedMediaSubscriptionEnum = ((keysToExclude: MediaSubscriptionMediaTypeEnum[]) => {
    return Object.fromEntries(
        Object.entries(MediaSubscriptionMediaTypeEnum).filter(([key, value]) => !keysToExclude.includes(value))
    );
})(
    /* exclusion array */
    Array.from([
        MediaSubscriptionMediaTypeEnum.tiktok,
        MediaSubscriptionMediaTypeEnum.subReddit,
        MediaSubscriptionMediaTypeEnum.linkedin,
        MediaSubscriptionMediaTypeEnum.bluesky
    ]));
